<template>
    <div class="font-body">
        <LandingNav
            background-color="#FFFFFF"
            logo-light="/hkcm/images/logo-on-light-background.svg"
            logo-small-light="/hkcm/images/logo-small-on-light-background.svg"
            :cta-text="'Analyse-Pakete entdecken'"
            cta-link="/produkte"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
            :show-ticker="true"
            ticker-text="+++ Ø<span class='font-semibold'> 70 % Trefferquote</span> über alle Analysebereiche +++ <span class='font-semibold'>Klare</span> Einstiegs-, Ausstiegs- und Risikomarken +++ <span class='font-semibold'>Strukturierte Szenarien</span> statt Bauchgefühl +++"
        />

        <!-- Hero Section -->
        <HeroSection
            background-color="linear-gradient(to bottom, #072551, #020E20)"
            :badges="heroBadges"
            title="Rohstoffanalysen der HKCM für bessere <span class='lg:break-normal break-all hyphens-manual'>Handelsentscheidungen</span>"
            title-highlight="Rohstoffanalysen"
            title-highlight-gradient-from="#E2C750"
            title-highlight-gradient-to="#E2C750"
            subtitle="Technische Analyse mit klaren Einstiegs- und Ausstiegsmarken."
            :benefits="heroBenefits"
            cta-text="Rohstoff-Analysen jetzt bestellen"
            :cta-link="{ name: 'products' }"
            :show-cta="true"
            button-gradient-from="#93802F"
            button-gradient-to="#E2C750"
            :social-proof-text="socialProofText"
            social-proof-image="/hkcm/images/rezensionenBilder.png"
            :app-store-data="appStoreData"
            :google-play-data="googlePlayData"
            checkmark-color="text-[#006CFF]"
            background-image="/hkcm/images/bg_candels.png"
        />

        <!-- Video Section -->
        <VideoSection
            background-color="transparent"
            video-url="https://iframe.mediadelivery.net/embed/369702/2e4e5500-9407-4346-bd52-3bc806c62047?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            discount-text="Rabatt"
            discount-percentage="20%"
            discount-badge-color="#1E40AF"
            :video-height="500"
        />

        <!-- Content Section: Bessere Anlageentscheidungen -->
        <ContentSection
            background-color="bg-white"
            title="Bessere Anlageentscheidungen<br> im Rohstoffhandel"
            title-color="text-blue-dark"
            title-highlight="Rohstoffhandel"
            title-highlight-gradient-from="#E2C750"
            title-highlight-gradient-to="#93802F"
            :paragraphs="contentText1"
            text-color="text-black"
            :show-cta="true"
            cta-text="Rohstoff-Analysen jetzt bestellen"
            :cta-link="{ name: 'products' }"
            button-gradient-from="#93802F"
            button-gradient-to="#E2C750"
            :stats="stats"
            :tiles="statsCards"
            :tiles-background="'bg-[#e5f0ff]'"
            :tiles-title-color="'text-[#006CFF]'"
            :tiles-description-color="'text-black'"
        />

        <!-- Feature Cards Section -->
        <FeatureCardsSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Was Sie in unseren<br> Aktienpaketen erhalten"
            title-highlight="Aktienpaketen"
            title-highlight-gradient-from="#E2C750"
            title-highlight-gradient-to="#93802F"
            title-color="text-white"
            :cards="featureCards"
            card-background-color="bg-white"
            card-title-color="text-black"
            card-text-color="text-black"
            card-icon-color="text-[#006CFF]"
            icon-size="text-[120px]"
            card-width="lg:w-[28rem] w-80"
            :show-cta="true"
            cta-text="Rohstoff-Analysen jetzt bestellen"
            :cta-link="{ name: 'products' }"
            button-gradient-from="#93802F"
            button-gradient-to="#E2C750"
        />

        <!-- Packages Section -->
        <AnalysePaketeSection
            background-color="linear-gradient(135deg, #E2C750 0%, #93802F 100%)"
            title="Folgende Rohstoffe analysieren<br class='lg:block hidden'> wir für Sie"
            title-color="text-black"
            title-highlight="Rohstoffe"
            title-highlight-color="text-white"
            icon-image="https://hkcm-storage.s3.eu-central-1.amazonaws.com/product-categories/rohstoffe-white.png"
            subtitle="Wählen Sie das Analysepaket passend zu Ihrem Marktinteresse und Ihrer Strategie."
            subtitle-color="text-black"
            :packages="commodityPackages"
            button-gradient-from="#E2C750"
            button-gradient-to="#93802F"
            icon-color="text-white"
        />

        <!-- Video Content Section: Was Rohstoffmärkte unterscheidet -->
        <VideoContentSection
            title="Was Rohstoffmärkte von Aktienmärkten unterscheidet"
            title-highlight="Rohstoffmärkte"
            title-highlight-gradient-from="#E2C750"
            title-highlight-gradient-to="#93802F"
            :content="contentText2"
            video-url="https://www.youtube.com/watch?v=example"
            :image-on-left="false"
            background-color="bg-white"
            title-color="text-blue-dark"
            text-color="text-black"
            position="right"
            :height="500"
            :image="$asset('/hkcm/images/methodology2.png', 'public')"
        />

        <!-- Wie wir Rohstoffmärkte strukturell analysieren -->
        <VideoContentSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Wie wir Rohstoffmärkte strukturell analysieren"
            title-highlight="Rohstoffmärkte"
            title-highlight-gradient-from="#E2C750"
            title-highlight-gradient-to="#93802F"
            title-color="text-white"
            content="Auch Rohstoffmärkte bewegen sich in wiederkehrenden Strukturmustern.<br>
    Die Elliott-Wellen-Methodik hilft dabei, Trendphasen und Korrekturen systematisch zu unterscheiden und Marktbewegungen objektiv einzuordnen.<br><br>
    Wir analysieren:<br>
    &nbsp;&nbsp;• Impulsphasen<br>
    &nbsp;&nbsp;• Korrekturstrukturen<br>
    &nbsp;&nbsp;• Einstiegs- und Ausstiegszonen<br>
    &nbsp;&nbsp;• Zielzonen<br>
    &nbsp;&nbsp;• Invalidation-Marken"
            text-color="text-white"
            video-url="https://iframe.mediadelivery.net/embed/369702/1c68b624-174f-4235-8ca3-f945035bbac1?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            :height="384"
            position="left"
        />

        <!-- 16) WHAT YOU GET SECTION -->
        <WhatYouGetSection
            title="Was Sie bei HKCM<br> konkret erhalten und<br> was nicht"
            title-highlight="HKCM"
            title-highlight-color="#E2C750"
            title-color="#ffffff"
            description="Damit keine falschen Erwartungen entstehen, ist uns Transparenz wichtig: <br>HKCM ist kein Broker, keine Handelsplattform und keine Vermögensverwaltung. Sie kaufen bei uns keine Rohstoffe und führen über uns keine Transaktionen aus. Stattdessen erhalten Sie strukturierte, methodisch abgeleitete Marktanalysen auf Basis der Elliott-Wellen-Theorie als fundierte Entscheidungsgrundlage für Ihre eigenen Investmententscheidungen."
            description-color="#ffffff"
            cta-text="Rohstoff-Analysen jetzt kaufen"
            cta-link="/produkte"
            cta-style="px-4 h-[64px] text-center mt-6 rounded-full font-semibold text-[20px] flex items-center gap-2 transition text-white hover:opacity-90 w-full justify-center lg:w-fit bg-gradient-to-r from-[#93802F] to-[#E2C750]"
            :image="$asset('/hkcm/images/frau_lp.png', 'public')"
            image-alt="HKCM Experte"
            :show-cta="true"
        />

        <!-- WHO IS IT FOR -->
        <WhoIsItForSection
            background-color="bg-white"
            title="Für wen unsere Analysen geeignet sind"
            title-highlight="Analysen"
            title-highlight-color="#E2C750"
            title-color="#000000"
            subtitle="Besonders geeignet sind die Analysen für Sie, wenn ..."
            subtitle-highlight="Analysen"
            intro-text="Unsere Rohstoff-Analysepakete richten sich an Anleger, die ihre Investmententscheidungen eigenständig treffen, dabei aber nicht auf Bauchgefühl oder Schlagzeilen vertrauen möchten.<br> Die Analysen liefern Ihnen strukturierte Marktmodelle, Szenarien und Kursmarken für Märkte wie Gold/GLD, Silber, Rohöl oder Erdgas.<br> Sie sind als Entscheidungsgrundlage gedacht, nicht als automatisches Handelssystem.<br> Damit Sie schnell erkennen können, ob unser Ansatz zu Ihnen passt, finden Sie hier eine klare Einordnung."
            intro-text-color="#000000"
            :cards="whoIsItForCards"
            card-border-color="#e5f0ff"
            card-title-color="#000000"
            card-text-color="#000000"
            icon-color="text-[#006CFF]"
            card-background="bg-[#e5f0ff]"
        />

        <!-- WICHTIG ZU VERSTEHEN -->
        <VideoContentSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Wichtig zu verstehen"
            title-highlight="verstehen"
            title-highlight-gradient-from="#E2C750"
            title-highlight-gradient-to="#93802F"
            title-color="text-white"
            content="Unsere Rohstoffanalysen sind ein Werkzeug für strukturierte Entscheidungen, kein Ersatz für eigene Verantwortung. Je aktiver und strukturierter Sie investieren, desto größer ist der praktische Nutzen der Analysen."
            text-color="text-white"
            video-url="https://iframe.mediadelivery.net/embed/369702/ff1074ac-8074-48a1-892e-7c93da909f75?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            :height="200"
            position="left"
            cta-text="Rohstoff-Analysen jetzt kaufen"
            cta-link="/produkte"
            button-gradient-from="#E2C750"
            button-gradient-to="#93802F"
        />

        <!-- HOW TO USE SECTION -->
        <HowToUseSection
            background-color="#ffffff"
            title="So nutzen Sie die Aktienanalysen"
            title-highlight="Aktienanalysen"
            title-highlight-color="#E2C750"
            title-color="#1a1a1a"
            :steps="howToUseSteps"
            disclaimer="HKCM bietet Marktanalysen und Szenarien auf Basis der Elliott-Wellen-Theorie. Es erfolgt keine Anlageberatung und keine Kaufabwicklung."
            disclaimer-color="#000"
            active-step-color="#006CFF"
            inactive-step-color="#1e3a5f"
            line-color="#1e3a5f"
            label-color="#1a1a1a"
        />

        <!-- WHO IS BEHIND HKCM -->
        <WhoIsBehindSection
            background-color="bg-[#006cff1a]"
            title="Wer hinter HKCM steht"
            title-highlight="HKCM"
            title-highlight-color="#E2C750"
            title-color="#000000"
            intro-text="Strukturierte Marktanalyse mit klarer Methodik, transparent, nachvollziehbar und regelmäßig aktualisiert. HKCM steht für strukturierte Marktanalyse statt Meinungsprognose. Unser Fokus liegt darauf, Rohstoffmärkte methodisch einzuordnen und daraus klare Szenarien sowie Kursmarken abzuleiten. Unsere Analysen basieren auf der Elliott-Wellen-Theorie. Nicht, weil sie kompliziert klingt, sondern weil sie Marktphasen und Korrekturen systematisch beschreibbar macht. Das Ziel ist nicht, Märkte perfekt vorherzusagen, sondern Ihnen ein nachvollziehbares Modell zu geben, mit dem Sie Entscheidungen strukturiert treffen können. Wir arbeiten mit einem szenariobasierten Ansatz. Das bedeutet: Sie erhalten nicht nur eine Richtung, sondern mehrere mögliche Entwicklungen, inklusive klarer Marken, ab wann ein Szenario bestätigt oder verworfen wird. So entsteht Orientierung, gerade in volatilen Rohstoffmärkten."
            intro-text-color="#000000"
            :paragraphs="[]"
            paragraph-color="#000000"
            image="/hkcm/images/team/pk.jpg"
            image-alt="Philip Klinkmüller"
            badge-top-text="Über"
            badge-main-text="70 %"
            badge-bottom-text="Trefferquote"
            :features="whoIsBehindFeatures"
            feature-title-color="text-[#006CFF]"
            feature-subtitle-color="#000000"
            checkmark-color="text-[#006CFF]"
        />

        <!-- FINAL CTA -->
        <FinalCTASection
            background-color="linear-gradient(to bottom, #072551, #020E20)"
            title="Finden Sie jetzt das passende Aktienanalyse-Paket für Ihre Strategie"
            title-highlight="Aktienanalyse-Paket"
            title-highlight-gradient-from="#E2C750"
            title-highlight-gradient-to="#E2C750"
            title-color="text-white"
            description="Alle Pakete basieren auf methodischer Marktanalyse statt Prognose, transparent und strukturiert abgeleitet."
            description-color="text-gray-200"
            image="/hkcm/images/zugang_zum_hype_aktien_paket.png"
            image-alt="Rohstoff Analyse"
            image-position="left"
            cta-text="Rohstoff-Analysen jetzt kaufen"
            cta-link="/produkte"
            button-gradient-from="#E2C750"
            button-gradient-to="#93802F"
            price-color="text-purple"
        />

        <!-- FOOTER -->
        <LandingFooter
            background-color="#FFFFFF"
            logo="/hkcm/images/logo-on-light-background.svg"
            logo-link="/produkte"
            link-color="text-gray-600"
            cta-text="Analyse-Pakete entdecken"
            cta-link="/produkte"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
        />
    </div>
</template>

<script setup>
import HeroSection from '../components/landing/HeroSection.vue';
import VideoSection from '../components/landing/VideoSection.vue';
import ContentSection from '../components/landing/ContentSection.vue';
import FeatureCardsSection from '../components/landing/FeatureCardsSection.vue';
import VideoContentSection from '../components/landing/VideoContentSection.vue';
import WhoIsItForSection from '../components/landing/WhoIsItForSection.vue';
import HowToUseSection from '../components/landing/HowToUseSection.vue';
import WhoIsBehindSection from '../components/landing/WhoIsBehindSection.vue';
import FinalCTASection from '../components/landing/FinalCTASection.vue';
import LandingFooter from '../components/landing/LandingFooter.vue';
import LandingNav from '../components/landing/LandingNav.vue';
import i18next from 'i18next';
import AnalysePaketeSection from '../components/landing/AnalysePaketeSection.vue';
import WhatYouGetSection from '../components/landing/WhatYouGetSection.vue';

// Hero Section Data
const heroBadges = [
    { src: '/hkcm/images/partners/BlackBull24_Krypto_square.png', alt: 'Black Bull Krypto Insider' },
    { src: '/hkcm/images/partners/BlackBull25_InvestmentVision.png', alt: 'Black Bull Krypto Insider' },
    { src: '/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png', alt: 'Black Bull Krypto Insider', class: 'w-full object-contain max-h-[180px] lg:w-auto' }
];

// Stats Cards
const statsCards = [
    { title: '+15', description: 'Jahre Erfahrung am Markt' },
    { title: '+15.000', description: 'Analysen<br> erstellt' },
    { title: '+1 mio.', description: 'Follower auf<br> YouTube' },
    { title: '+290', description: 'Durchschnittlich<br>Analysen im Monat' }
];

const heroBenefits = [
    'Szenario-basierte<br class="lg:block hidden"> Rohstoffanalysen',
    'Konkrete Kursmarken &<br class="lg:block hidden"> Strukturzonen',
    'Regelmäßige<br class="lg:block hidden"> Updates',
    'Methodik statt News-<br class="lg:block hidden">Interpretation'
];

const socialProofText = 'Bereits über 25.000<br> zufriedene Kunden';

const appStoreData = {
    link: 'https://apps.apple.com/de/app/hkcm/id6499010943',
    badge: i18next.language === 'de' ? '/hkcm/images/apple-store-badge.png' : '/hkcm/images/apple-store-badge-en.png',
    rating: '4.4',
    stars: '/hkcm/images/stars4_5_yellow.png',
    reviews: '1.8k'
};

const googlePlayData = {
    link: 'https://play.google.com/store/apps/details?id=de.hkcm.app&hl=de&pli=1',
    badge: i18next.language === 'de' ? '/hkcm/images/google-play-badge.png' : '/hkcm/images/google-play-badge-en.png',
    rating: '4.5',
    stars: '/hkcm/images/stars4_5_green.png',
    reviews: '7.3k'
};
// Content Section Data
const contentText1 =
    'Viele Anleger starten im Rohstoffmarkt mit einem naheliegenden Ansatz. <br>Sie reagieren auf Nachrichten, Energiepreise oder kurzfristige Kursbewegungen.<br> Das Problem ist fehlende Struktur.<br><br>Nachrichten sagen selten, was Anleger wirklich brauchen.<br> Nämlich zwei einfache Antworten: Wo investiere ich mein Geld und wann.<br> Ohne methodische Marktstruktur entstehen typische Fehler:<br>' +
    '<ul style="list-style-type:disc; margin-left: 30px; margin-bottom: 10px;">' +
    '<li class="text-sm"><span class="text-[18px]">Einstieg ohne Plan</span></li>' +
    '<li class="text-sm"><span class="text-[18px]">Kein Risikomanagement</span></li>' +
    '<li class="text-sm"><span class="text-[18px]">Meinungen statt Marken</span></li>' +
    '<li class="text-sm"><span class="text-[18px]">Reaktion statt Entscheidung</span></li>' +
    '</ul>' +
    'Unsere Rohstoffprodukte liefern strukturierte Analysen und klar definierte Kursmarken, auf Basis der Elliott-Wellen-Methodik.';

const stats = [
    { value: '+15', label: 'Jahre Erfahrung am<br> Markt' },
    { value: '+15.000', label: 'Analysen<br> erstellt' },
    { value: '+1 mio.', label: 'Follower auf<br> YouTube' },
    { value: '+290', label: 'Durchschnittlich<br> Analysen im Monat' }
];

// Feature Cards Data
const featureCards = [
    {
        title: 'Klare<br> Handelsmöglichkeiten',
        icon: '/hkcm/images/icons/rohstoff/icon_crosshair.svg',
        content: 'Ein- und Ausstiegszonen auf Basis der Elliott-Wellen-Analysen zum einfachen Nachhandeln. Per Mail, direkt in der App oder im HKCM-Dashboard.'
    },
    {
        title: 'Zugang zum<br> Musterportfolio',
        icon: '/hkcm/images/icons/rohstoff/icon_briefcase.svg',
        content: 'Unser Musterportfolio macht unsere Performance und Handelsentscheidungen jederzeit nachvollziehbar.'
    },
    {
        title: 'Tägliche<br> Analyse',
        icon: '/hkcm/images/icons/rohstoff/icon_chartline.svg',
        content: 'In detaillierten schriftlichen Rohstoffanalysen erhalten Sie werktäglich Updates zu Gold/GLD, Silber, Edelmetallen, Rohöl und Erdgas.'
    },
    {
        title: 'Schnelle Reaktionen auf<br> Marktbewegungen',
        icon: '/hkcm/images/icons/rohstoff/icon_lightning.svg',
        content: 'Bei starken Kursbewegungen oder wichtigen Ereignissen erhalten Sie kurze Updates – direkt als Kurznachricht in Ihrem Dashboard oder in der HKCM-App.'
    },
    {
        title: 'Für alle Trader<br> und Investoren',
        icon: '/hkcm/images/icons/rohstoff/icon_usersthree.svg',
        content:
            'Ob langfristig oder kurzfristig, Sie profitieren von klar definierten Einstiegs-, Ausstiegs-, Take-Profit- und Stoppmarken, die Ihnen Orientierung und Struktur im Handel geben.'
    },
    {
        title: 'Übersichtliche<br> Chartbilder',
        icon: '/hkcm/images/icons/rohstoff/icon_chartbar.svg',
        content:
            'Mit klar markierten Unterstützungen, Widerständen und Zielzonen geben Ihnen die Chartbilder eine wertvolle Orientierung, sowohl auf der Long- als auch auf der Short-Seite.'
    }
];

// Commodity Packages Data
const commodityPackages = [
    {
        name: 'Edelmetalle',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/edelmetalle.png',
        link: '/produkte/edelmetalle',
        infoText: 'Edelmetalle'
    },
    {
        name: 'Gold/GLD',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/gold.png',
        link: '/produkte/gold',
        infoText: 'Gold/GLD'
    },
    {
        name: 'Silber',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/silber.png',
        link: '/produkte/silber',
        infoText: 'Silber'
    },
    {
        name: 'Rohöl',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/wti-brent.png',
        link: '/produkte/rohoel',
        infoText: 'Rohöl'
    },
    {
        name: 'Erdgas',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/gas.png',
        link: '/produkte/erdgas',
        infoText: 'Erdgas'
    }
];

// Video Content Sections Data
const contentText2 =
    'Rohstoffe sind keine Unternehmen, sondern physische Güter wie Edelmetalle, Energie oder Industriemetalle. Ihre Preisbewegungen entstehen nicht durch Unternehmenszahlen, sondern durch globale Marktkräfte.<br><br> Dazu zählen insbesondere:<br>&nbsp;&nbsp;• Zinsumfeld und Inflationserwartungen<br>&nbsp;&nbsp;• Währungsbewegungen (vorwiegend der US-Dollar)<br>&nbsp;&nbsp;• Geopolitische Entwicklungen und Energiepolitik<br>&nbsp;&nbsp;• Angebots- und Nachfrageschwankungen sowie saisonale Effekte<br><br>Gerade Märkte wie Gold, Silber, Rohöl oder Erdgas reagieren häufig sensibel auf politische Entscheidungen, wirtschaftliche Veränderungen und strukturelle Angebotslagen. Dadurch entstehen oft schnellere und volatilere Bewegungen als an klassischen Aktienmärkten.<br><br>Eine strukturierte Chart- und Marktanalyse hilft dabei, diese Dynamik einzuordnen, klare Kurszonen zu identifizieren und Handelsentscheidungen nicht aus dem Bauch heraus zu treffen.';

// Who Is It For Cards
const whoIsItForCards = [
    {
        title: '… Sie Ihre Investmententscheidungen<br> selbst treffen',
        description:
            'Sie möchten nicht blind Empfehlungen folgen, sondern nachvollziehen, warum bestimmte Marktbewegungen entstehen können. Unsere Analysen zeigen Struktur, Szenarien und Entscheidungsmarken. Die Umsetzung liegt bei Ihnen.',
        icon: '/hkcm/images/landing-icons/brain.svg'
    },
    {
        title: '… Sie mit Kursmarken und Szenarien<br> arbeiten möchten',
        description:
            'Unsere Methodik liefert keine pauschalen „Kaufen / Verkaufen"-Aussagen. Stattdessen erhalten Sie konkrete Marktmarken und alternative Szenarien. Das ist ideal für Anleger, die strukturiert planen und Entscheidungen an klaren Bedingungen ausrichten möchten.',
        icon: '/hkcm/images/landing-icons/chart-line-up.svg'
    },
    {
        title: '… Sie regelmäßig Kapital in Aktien investieren',
        description:
            'Die Analysepakete entfalten ihren größten Nutzen für Anleger, die fortlaufend investieren oder bestehende Positionen aktiv managen. Wenn Sie monatlich oder regelmäßig Kapital am Markt einsetzen, helfen strukturierte Marktanalysen besonders bei Timing- und Risikofragen.',
        icon: '/hkcm/images/landing-icons/coins.svg'
    },
    {
        title: '… Sie Marktbewegungen besser verstehen<br> wollen',
        description:
            'Viele Nutzer schätzen unsere Analysen nicht nur wegen der Marken — sondern wegen des Marktverständnisses. Sie lernen zu erkennen: in welcher Marktphase sich ein Index befindet, ob eine Bewegung strukturell stabil wirkt, wo Korrekturen typisch sind, wann Strukturen brechen. Das stärkt Ihre eigene Entscheidungskompetenz.',
        icon: '/hkcm/images/landing-icons/lightbulb.svg'
    }
];

// How to Use Steps
const howToUseSteps = [
    {
        label: 'Analysepaket\nauswählen',
        active: true,
        icon: {
            paths: [
                {
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'stroke-width': '2',
                    d: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'
                }
            ]
        }
    },
    {
        label: 'Zugriff\nerhalten',
        active: false,
        icon: {
            paths: [
                {
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'stroke-width': '2',
                    d: 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z'
                }
            ]
        }
    },
    {
        label: 'Kursmarken &\nSzenarien einsehen',
        active: false,
        icon: {
            paths: [
                {
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'stroke-width': '2',
                    d: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
                }
            ]
        }
    },
    {
        label: 'Eigene Entscheidungen\nableiten',
        active: false,
        icon: {
            paths: [
                {
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'stroke-width': '2',
                    d: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
                }
            ]
        }
    }
];

// Who Is Behind Section Data
const whoIsBehindFeatures = [
    { title: 'Methodik statt Meinung', subtitle: 'feste<br> Analyse-Logik' },
    { title: 'Szenarien statt Prognosen', subtitle: 'klar definierte<br> Bedingungen' },
    { title: 'Kursmarken statt Bauchgefühl', subtitle: 'transparente<br> Entscheidungszonen' },
    { title: 'Regelmäßige Updates', subtitle: 'Anpassungen bei<br> Marktveränderungen' }
];
</script>

<style scoped>
.landing-page {
    overflow-x: hidden;
}
</style>
